<template>
    <div id="bIndustry">
        <tabtop></tabtop>
        <div class="solution1">
            <img :src="url+banner.images[0]" alt=""  @click="jumpbannerpage(banner.url,0)">
        </div>

        <div class="pcEducation1">
            <p class="title">美容减肥等行业的痛点</p>
            <ul>
                <li v-for="(item,index) in solution2" :key="index" class="wow animate__animated animate__fadeIn">
                    <img :src="item.icon" alt="">
                    <p class="p1">{{item.title}}</p>
                    <p class="p2">{{item.subtitle}}</p> 
                </li>
            </ul>
        </div>
        <div class="solution4">
            <ul>
                <li v-for="(item,index) in solution4" :key="index"  class="wow animate__animated animate__fadeIn">
                    <p class="p1">{{item.title}}</p>
                    <p class="p2">{{item.subtitle}}</p> 
                    <img :src="item.icon" alt="">
                </li>
            </ul>
        </div>
        <div class="pcEducation2">
            <button class="button1" @click="submit(false)">免费试用</button>
            <button class="button2" @click="submit(true)">立即咨询</button>
        </div>
        <webbottom></webbottom>
        <mydialog v-if="showtc2" @tcstatus="tcstatus" :dialogVisible1="tcshow"></mydialog>
    </div>
</template>

<script>
var that
import { rotationmap } from '@/api/api'
import mydialog from '@/components/dialog/dialog.vue'
import tabtop from '@/components/tab/tab.vue'
import webbottom from '@/components/bottom/bottom.vue'
export default {
    name:"solution",
    components: {
        tabtop,
        webbottom,
        mydialog
    },
    data(){
        return {
            url : window.url,
            banner:{},
            showtc2:false,
            tcshow:true,
            solution2:[
                {
                    icon:require('@/assets/solution/bIndustry1.png'),
                    title:"注重营销，获客成本高",
                    subtitle:"获客依赖营销推广，线上投放广告费用高而效果低，压缩利润空间",
                },
                {
                    icon:require('@/assets/solution/bIndustry2.png'),
                    title:"客户决策时间久成单周期长",
                    subtitle:"行业机构与客户信息不对称，客户顾虑多，对店员缺少信任",
                },
                {
                    icon:require('@/assets/solution/bIndustry3.png'),
                    title:"信息化管理水平低",
                    subtitle:"纯人工管理，多服务角色对接混乱，效率低，造成客户流失",
                },
                {
                    icon:require('@/assets/solution/bIndustry4.png'),
                    title:"客户选择线上商家无线上途径",
                    subtitle:"部分客户出于隐私心理，会选择线上店铺了解咨询及下单",
                }
            ],

            solution4:[
                {
                    icon:require('@/assets/solution/bIndustry5.png'),
                    title:"亿宝易帮你解决痛点打造医美行业营销新生态",
                    subtitle:"打造一套完整的引流拓客、运营维护、社群营销、用户管理、裂变转化的闭环体系",
                },
                {
                    icon:require('@/assets/solution/bIndustry6.png'),
                    title:"精打细算，降低获客成本",
                    subtitle:"提供个微企微裂变、社群裂变、红包裂变等多种营销工具，实现快速引流根据数据统计测算出低成本高成效的流量投放渠道，节省流量成本 ",
                },
                {
                    icon:require('@/assets/solution/bIndustry7.png'),
                    title:"精准营销，做有温度的商家",
                    subtitle:"能与企业的CRM系统打通，同步数据，整合信息自动客户标签，操作简单挖掘客户需求，提供个性化解决方案，给予客户温度",
                },
                {
                    icon:require('@/assets/solution/bIndustry10.png'),
                    title:"增强客户信任，做专业的变美顾问",
                    subtitle:"提供店铺朋友圈、优惠券拼团等窗口功能及营销工具，传递公司信息配合营销方法快速变现话术SOP与问答栏，积累销售话术，企微一键发送客户，快速解答问题，体现专业",
                },
                {
                    icon:require('@/assets/solution/bIndustry8.png'),
                    title:"全流程线上化管理，保护客户隐私资源不流失",
                    subtitle:"线上线下隔阂打通，O2O模式最大限度实现资源互通，客户精准服务更周到离职继承，客户转移给在职员工，可同步客户信息，保护公司客源",
                },
                {
                    icon:require('@/assets/solution/bIndustry9.png'),
                    title:"亿宝易系统提供完整顾客经营数字化解决方案",
                    subtitle:"帮助实体门店搭建私域流量池，构建可持续发展的顾客经营体系",
                }
            ]
        }
    },
    mounted(){
        that = this
        //初始化动画
        rotationmap({'type':5}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner = response.data.data[0]
            this.$nextTick(()=>{
                this.$wow.init()
            })
        })
    },
    methods:{
        tcstatus(e){
            this.showtc2 = e
        },
        submit(e){
            this.showtc2 = true
            this.tcshow = e
        },
        jumpbannerpage(e,y){
            this.showtc2 = true
            let url = e.split(',')
            if(url[y] != this.$route.path) {
                this.$router.push(url[y])
            }
        }
    }
}
</script>

<style lang="less">
    :root {
        --web-title-fontsize: 30px;
        --web-subtitle-fontsize: 22px;
        --web-text-fontsize: 16px;
    } 
    @media (min-width:750px) {
        #bIndustry{
            .solution1{
                img{
                    width: 100%;
                }
            }
            .pcEducation1{
                margin:0 auto 0;
                background-color: #F5F8FF;
                padding: 70px 0;
                .title{
                    font-size: var(--web-title-fontsize);
                    font-weight: 800;
                    color: #222222;
                    text-align: center;
                }
                ul{
                    width: 1300px;
                    margin:50px auto 0;
                    display: flex;
                    justify-content: space-between;
                    text-align: center;
                    li{
                        padding: 32px;
                        background: #FFFFFF;
                        border-radius: 16px;
                        img{
                            width: 80px;
                            margin-bottom: 8px;
                        }
                        .p1{
                            width:221px;
                            font-size: var(--web-subtitle-fontsize);
                            font-weight: 500;
                            color: #343434;
                            margin: 0 auto 15px;
                        }
                        .p2{
                            width: 204px;
                            font-size: var(--web-text-fontsize);
                            font-weight: 400;
                            color: #777777;
                            margin: 0 auto 0;
                        }
                    }
                    li:hover{
                        background: linear-gradient(180deg, #D8EEFF 0%, #D6E9FF 100%);
                        box-shadow: 0px 12px 20px 1px #C5D9FF;
                    }
                }
            }
            .pcEducation2{
                display: flex;
                justify-content: center;
                margin-bottom: 57px;
                .button1{
                    margin-right: 60px;
                    background: #355EFC;
                    border-radius: 61px 61px 61px 61px;
                    font-size: var(--web-text-fontsize);
                    font-weight: 500;
                    color: #FFFFFF;
                    text-align: center;
                    padding: 18px 60px;
                    cursor: pointer;
                }
                .button2{
                    border-radius: 61px 61px 61px 61px;
                    border: 1px solid #355EFC;
                    font-size: var(--web-text-fontsize);
                    font-weight: 500;
                    color: #355EFC;
                    padding: 18px 60px;
                    background-color: transparent;
                    cursor: pointer;
                }
            }
            .solution4{
                margin-top: 40px;
                ul{
                    width: 1300px;
                    margin:0 auto;
                    li{
                        .p1{
                            font-size: var(--web-title-fontsize);
                            font-weight: 800;
                            color: #222222;
                            text-align: center;
                            margin-bottom: 20px;
                        }
                        .p2{
                            width: 1000px;
                            font-size: var(--web-subtitle-fontsize);
                            font-weight: 500;
                            color: #808080;
                            text-align: center;
                            margin:0 auto 49px;
                        }
                        img{
                            width: 739px;
                            display: block;
                            margin: 0 auto 60px;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width:750px) {
        #bIndustry{
            .solution1{
                img{
                    width: 100%;
                }
            }
            .pcEducation1{
                margin:0 auto 0;
                background-color: #F5F8FF;
                padding: 1.875rem 0;
                .title{
                    font-size: 1.5rem;
                    font-weight: 800;
                    color: #222222;
                    text-align: center;
                }
                ul{
                    width: 90%;
                    margin:3.125rem auto 0;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    li{
                        flex:0 0 45%;
                        background: #FFFFFF;
                        box-shadow: 0rem 0.1875rem 0.375rem 0.0625rem rgba(0,0,0,0.16);
                        border-radius: 0.625rem;
                        padding: 1.25rem 1.25rem 0.625rem 1.25rem;
                        margin-bottom: 2.5rem;
                        img{
                            width: 2.5rem;
                            display: block;
                            margin-bottom: 1rem;
                        }
                        .p1{
                            font-size: 0.75rem;
                            font-weight: bold;
                            color: #3D3D3D;
                            position: relative;
                            display: inline-block;
                            z-index: 9;
                            margin-bottom: 0.75rem;
                        }
                        .p1::after{
                            content:"";
                            display: block;
                            width: 110%;
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            height: 0.375rem;
                            background: #7FD7FE;
                            z-index: -1;
                        }
                        .p2{
                            font-size: 0.75rem;
                            font-weight: 400;
                            color: #3D3D3D;
                        }
                    }
                }
            }
            .solution4{
                margin-top: 1.75rem;
                ul{
                    width: 100%;
                    margin:0 auto;
                    li{
                        .p1{
                            font-size: 1.5rem;
                            font-weight: 800;
                            color: #222222;
                            text-align: center;
                            margin-bottom: 1.25rem;
                        }
                        .p2{
                            width: 90%;
                            font-size: 1.25rem;
                            font-weight: 500;
                            color: #808080;
                            text-align: center;
                            margin:0 auto 3.0625rem;
                        }
                        img{
                            width: 100%;
                            margin-bottom: 3.75rem;
                        }
                    }
                }
            }
            .pcEducation2{
                display: flex;
                justify-content: center;
                margin-bottom: 20px;
                .button1{
                    margin-right: 30px;
                    background: #355EFC;
                    border-radius: 61px 61px 61px 61px;
                    font-size: 20px;
                    font-weight: 500;
                    color: #FFFFFF;
                    text-align: center;
                    padding: 10px 20px;
                }
                .button2{
                    border-radius: 61px 61px 61px 61px;
                    border: 1px solid #355EFC;
                    font-size: 20px;
                    font-weight: 500;
                    color: #355EFC;
                    padding: 10px 20px;
                    background-color: transparent;
                }
            }
        }
    }
</style>